export enum ACTION_TYPES {
  SET_VERIFICATION_CODE = 'SET_VERIFICATION_CODE',
  COUNTDOWN_FINISHED = 'COUNTDOWN_FINISHED',
  REQUESTING_OTP = 'REQUESTING_OTP',
  REQUESTED_OTP = 'REQUESTED_OTP',
  FAILED_OTP = 'FAILED_OTP'
}

export interface ActionSetVerificationCode {
  type: typeof ACTION_TYPES.SET_VERIFICATION_CODE;
  value: string;
}

export interface ActionCountdownFinished {
  type: typeof ACTION_TYPES.COUNTDOWN_FINISHED;
}

export interface ActionRequestingOtp {
  type: typeof ACTION_TYPES.REQUESTING_OTP;
}

export interface ActionRequestedOtp {
  type: typeof ACTION_TYPES.REQUESTED_OTP;
}

export interface ActionFailedOtp {
  type: typeof ACTION_TYPES.FAILED_OTP;
}

export type ActionTypes =
  | ActionSetVerificationCode
  | ActionCountdownFinished
  | ActionRequestingOtp
  | ActionRequestedOtp
  | ActionFailedOtp;

export const initialState = {
  isRequesting: false,
  canRequestNewCode: false,
  hasVerificationError: false,
  hasCountdownEnded: false,
  verificationCode: ''
};

export const reducer = (state: typeof initialState, action: ActionTypes) => {
  switch (action.type) {
    case ACTION_TYPES.SET_VERIFICATION_CODE:
      return {
        ...state,
        verificationCode: action.value
      };
    case ACTION_TYPES.COUNTDOWN_FINISHED:
      return {
        ...state,
        hasCountdownEnded: true,
        canRequestNewCode: true
      };
    case ACTION_TYPES.REQUESTING_OTP:
      return {
        ...state,
        isRequesting: true,
        hasVerificationError: false
      };
    case ACTION_TYPES.REQUESTED_OTP:
      return {
        ...state,
        isRequesting: false,
        hasCountdownEnded: false,
        canRequestNewCode: false
      };
    case ACTION_TYPES.FAILED_OTP:
      return {
        ...state,
        isRequesting: false,
        hasVerificationError: true
      };
    default:
      return state;
  }
};
